import { IPremadeQuiz, IQuiz } from '@quizzach/interfaces';

const openInNewTab = (url: string) => {
	const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
	if (newWindow) newWindow.opener = null;
};

//TODO: rename thematic_quizzes uploads folder on server
export const handleDownloadTemplate = (quiz: IQuiz) => {
	openInNewTab(
		`${import.meta.env.VITE_ASSETS_URL}/thematic_quizzes/${quiz?.premade_quiz
			?.answers_template}`
	);
};

// same thing as the above, but used on PremadeQuizzes-Single where I don't have the full quiz object
export const handleDownloadPremadeTemplate = (quiz: IPremadeQuiz) => {
	openInNewTab(
		`${
			import.meta.env.VITE_ASSETS_URL
		}/thematic_quizzes/${quiz?.answers_template}`
	);
};

export const handleDownloadPromoRetrospectiveTemplate = () => {
	openInNewTab(
		`https://quizzach.com/uploads/thematic_quizzes/Premade-template-retrospektiva-1-6942472dc0957.pdf`
	);
};
